import React from "react";
import { Autocomplete, TextField } from "@mui/material";

export interface MultiSelectOption {
  value: string;
  label: string;
}

interface MultiSelectSearchProps {
  options: MultiSelectOption[];
  selected: string[];
  onChange: (selected: string[]) => void;
  label?: string;
  placeholder?: string;
}

const MultiSelectSearch: React.FC<MultiSelectSearchProps> = ({
  options,
  selected,
  onChange,
  label,
  placeholder,
}) => {
  const selectedOptions = options.filter((opt) => selected.includes(opt.value));

  const handleChange = (_: any, newValues: MultiSelectOption[]) => {
    onChange(newValues.map((opt) => opt.value));
  };

  return (
    <Autocomplete
      multiple
      options={options}
      value={selectedOptions}
      onChange={handleChange}
      getOptionLabel={(option) => option.label}
      isOptionEqualToValue={(option, value) => option.value === value.value}
      ListboxProps={{
        sx: {
          maxHeight: "200px",
          overflowY: "auto",
        },
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          placeholder={placeholder}
          variant="outlined"
          size="small"
        />
      )}
    />
  );
};

export default MultiSelectSearch;